import { render } from "./HomeClientes.vue?vue&type=template&id=5a70f94e&scoped=true"
import script from "./HomeClientes.vue?vue&type=script&lang=js"
export * from "./HomeClientes.vue?vue&type=script&lang=js"

import "./HomeClientes.vue?vue&type=style&index=0&id=5a70f94e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a70f94e"]])

export default __exports__